<script setup>
import { RouterView } from 'vue-router'
import { useHead } from '@unhead/vue'
import { useThemeStore } from '@/stores/theme'
import { computed } from 'vue'
import MainHeader from '@/components/layout/MainHeader.vue'
import MainFooter from '@/components/layout/MainFooter.vue'
import LoadingScreen from '@/components/layout/LoadingScreen.vue'

const themeStore = useThemeStore()

// Dynamic title template based on current theme
const titleTemplate = computed(() => {
  const companyName = themeStore.currentTheme?.name || 'Skadesvar'
  return (title) => (title ? `${title} - ${companyName}` : companyName)
})

const showLoadingScreen = computed(() => !themeStore.initialLoadComplete)

useHead({
  titleTemplate,
})
</script>

<template>
  <div id="app">
    <LoadingScreen v-if="showLoadingScreen" />
    <template v-else>
      <MainHeader />
      <main class="page-wrapper">
        <router-view></router-view>
      </main>
      <MainFooter
    /></template>
  </div>
</template>
